<template>
    <div class="navbar" ref="navbarRef">
        <hamburger id="hamburger-container" :is-active="sidebar.opened" class="hamburger-container"
                   @toggleClick="toggleSideBar"/>
        <div class="flex justify-between items-center h-full">
            <div class="flex-1">
                <div class="flex items-center">
                    <div
                        ref="routeNameRef"
                        class="mx-4 bold"
                        style="white-space: nowrap;font-size: 14px;"
                    >
                        {{ routeName }}
                    </div>
                </div>
                <div v-show="showTagsView" :style="`width: ${tagsWidth}px`">
                    <TagsView @addTags="resizeWindow"/>
                </div>
                <!-- <div>
                  模拟菜单
                </div> -->
            </div>
            <div class="flex items-center" :style="`min-width: ${rightWidth}px;`">
                <el-select
                    :value="languageValue"
                    @change="(e) => changeLanguage(e)"
                    size="small"
                    class="select-language"
                >
                    <!-- 前置图标 -->
                    <template #prefix>
                        <div class="select-img">
                            <img src="../../assets/images/language-change.png" alt="">
                        </div>
                    </template>
                    <!-- <el-option value="zh-CN" label="中文">{{ `中文${$te('zh-CN') ? '-' + $t('zh-CN') : ''}` }}</el-option>
                    <el-option value="en-US" label="English">{{ `English${$te('en-US') ? '-' + $t('en-US') : ''}` }}</el-option>
                    <el-option value="de-DE" label="Deutsch">{{ `Deutsch${$te('de-DE') ? '-' + $t('de-DE') : ''}` }}</el-option>
                    <el-option value="fr-FR" label="Français">{{ `Français${$te('fr-FR') ? '-' + $t('fr-FR') : ''}` }}</el-option>
                    <el-option value="it-IT" label="Italiano">{{ `Italiano${$te('it-IT') ? '-' + $t('it-IT') : ''}` }}</el-option>
                    <el-option value="uk-UA" label="Українська Мова">{{ `Українська Мова${$te('uk-UA') ? '-' + $t('uk-UA') : ''}` }}</el-option>
                    <el-option value="th-TH" label="ภาษาไทย">{{ `ภาษาไทย${$te('th-TH') ? '-' + $t('th-TH') : ''}` }}</el-option> -->
                    <el-option
                        v-for="item in languageSelectList"
                        :key="item.value"
                        :value="item.value"
                        :label="item.commandLabel"
                    >
                        {{ `${item.commandLabel}${$te(item.value) ? '-' + $t(item.value) : ''}` }}
                    </el-option>
                </el-select>
                <div class="chat-region" v-if="showRobotIcon" ref="modalRef">
                    <!-- <i class="el-icon-help aside_btn" style="color: #ffffff;font-size: 20px"></i>                           -->
                    <div class="img-region" @click="handleRobotShow">
                        <img src="../../assets/images/smart.png" width="26" alt="">
                    </div>
                    <iframe
                        :src="iframeSrc"
                        frameborder="0"
                        allow="*"
                        referrerpolicy="no-referrer"
                        title="FastDeepSeek Chat Window"
                        id="fastdeepseek-chatbot-window"
                        class="fastdeepseek-chatbot-window"
                        :style="`visibility: ${showRobot ? 'unset' : 'hidden'}`"
                    >
                    </iframe>
                </div>
                <div
                    v-if="showPrefillIcon"
                    class="prefill-region"
                    ref="modalRefPrefill"
                    :style="`visibility: ${showPrefill ? 'unset' : 'hidden'}`"
                >
                    <iframe
                        v-if="showPrefill"
                        src="https://ihaier.feishu.cn/share/base/form/shrcnK8RlKoVb51I11KDKg6rIch?prefill_系统来源=HaierEnergyWeb&prefill_调研表信标=${id}&hide_系统来源=1&hide_调研表信标=1"
                        frameborder="0"
                        allow="*"
                        referrerpolicy="no-referrer"
                        title="Prefill Window"
                        id="prefill-window"
                        class="prefill-window"
                    >
                    </iframe>
                </div>
                <el-dropdown trigger="click" size="medium" placement="bottom">
                    <div class="user flex items-center">
                        <el-avatar class="avatar" :size="28" :src="Avatar" style="background: #fff"/>
<!--                        <img src="../../assets/images/user-icon.png" class="user-avatar">-->
                        <span class="user-name ml-2">{{ userName }}</span>
                    </div>
                    <el-dropdown-menu slot="dropdown" :style="{ width: '150px', 'text-align': 'center' }">
                        <el-dropdown-item v-if="versionData" @click.capture.native="showVersion()">
                            {{ $t('common.currentVersion') }}
                        </el-dropdown-item>
                        <el-dropdown-item v-if="showPrefillIcon" @click.capture.native="handlePrefillShow()">
                            {{ $t('sidebar.prefill') }}
                        </el-dropdown-item>
                        <el-dropdown-item @click.capture.native="logout()">
                            {{ $t('sidebar.logout') }}
                        </el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
        </div>
    </div>
</template>

<script>
let timeout = null
import { newLogout } from '@/api/api';
import { checkVersion } from '@/api/appversion';
import { mapState, mapGetters, mapActions } from 'vuex'
import Hamburger from './Hamburger'
import TagsView from './TagsView'
import {languageDropDown} from '@/utils/common.js'
import langConfig from '@/Language/config.json'

const {languageSelectList} = langConfig

export default {
    name: 'NavBar',
    components: {
        Hamburger,
        TagsView,
    },
    data() {
        return {
            languageSelectList,
            tagsWidth: 600,
            rightWidth: 380,
            hamburgerWidth: 50,
            showTagsView: true,
            userName: '',
            showRobotIcon: false,
            showPrefillIcon: false,
            languageValue: this.$i18n.locale,
            Avatar: require('@/assets/images/avatar.svg'),
            versionData: null
        }
    },
    created() {
        // 根据域名判断是否显示机器人图标
        this.showRobotIcon = [
            'localhost',
            'intelligent-test.nahui-newenergy.com',
            'hems.haier-energy.com',
        ].includes(window.location.hostname)
        this.showPrefillIcon = [
            'localhost',
            'intelligent-test.nahui-newenergy.com',
            'hems.haier-energy.com',
        ].includes(window.location.hostname) && (this.$i18n.locale === 'zh-CN')
        this.checkVersionFun()
    },
    mounted() {
        this.initMounted()
        window.addEventListener('resize', this.resizeWindow)
        this.$once('hook:beforeDestroy', function () {
            window.removeEventListener('resize', this.resizeWindow)
        })
        // 模拟窗口变化
        window.dispatchEvent(new Event('resize'));
    },
    computed: {
        ...mapState('cookie', ['consent']),
        ...mapGetters([
            'sidebar',
            'showRobot',
            'showPrefill',
        ]),
        routeName() {
            return this.$route.meta?.title ? this.$t(this.$route.meta?.title) : '-'
        },
        isCollapse() {
            return !this.sidebar.opened;
        },
        iframeSrc() {
            const baseUrl = process.env.VUE_APP_BASE_URL || '';
            return `${baseUrl}&memberId=${this.userName}&from=haierEnergy`;
        },
    },
    methods: {
        ...mapActions('token', ['updateToken']),
        initMounted() {
          const domain = window.location.hostname;
          sessionStorage.setItem("DNS", domain)
          this.dns_ym = domain
          let userInfo = this.userInfo || JSON.parse(localStorage.getItem('userInfo'))
          let userAccount = JSON.parse(localStorage.getItem('userAccount'))
          this.userName = userAccount?userAccount:'-'
          this.userId = userInfo.id
          this.clientId = userInfo.clientId
          this.address = userInfo.address
          // 只在生产环境加载并初始化 ARMS，且用户已同意性能监控
          if (['pre', 'production'].includes(process.env.NODE_ENV) && this.consent?.performance) {
            // 动态导入 @arms/rum-browser
            import('@arms/rum-browser').then(({ default: ArmsRum }) => {
                ArmsRum.init({
                  pid: process.env.VUE_APP_ARMS_PID,
                  endpoint: process.env.VUE_APP_ARMS_endpoint,
                  env: 'prod',
                  spaMode: 'history',
                  collectors: {
                      perf: true,                 // 页面性能
                      webVitals: true,            // lcp等指标
                      api: true,                 // 接口监听
                      staticResource: true,      // 静态资源
                      jsError: true,            // js报错
                      consoleError: false,      // 控制台报错
                      action: false, // 临时关闭用户行为采集（它会读组件树！）
                  },
                  filters: {
                    resource: [
                      "https://mon.zijieapi.com/monitor_browser/collect/batch/?biz_id=docs_bitable_form_share",
                      "https://mcs-bd.feishu.cn/list"
                    ]
                  },
                  user: {
                    name: userAccount || '', // 用户名
                    id: userInfo.id || '', // 用户ID（可选）
                    email: userInfo.email || '', // 邮箱（可选）
                    // custom: { dept: 'tech' } // 自定义字段（可选）
                  },
                  tracing: true
                });
            })
          }
        },
        checkVersionFun() {
            checkVersion({
                phoneOs: 3, // 暂定3 为web端版本
                appVersion: '1.0.0',
                projectType: 2, // 2: '海尔', 3: '乌克兰'
                versionType: process.env.NODE_ENV === 'production' ? 1 : 2,
                nowSerialNum: '2026022501'
            }).then(res => {
                if (!res || typeof res !== 'object') return;
                const {success, code, message, data} = res
                if (success || ['200'].includes(String(code))) {
                    if (data && Object.keys(data).length > 0) {
                        // const { needUpgrade, forceUpgrade, systemVersion, versionDesc, versionDescEn } = data
                        this.versionData = { ...data }
                    }
                } else {
                    this.$message({
                        type: 'error',
                        message: message,
                    });
                }
            })
        },
        showVersion() {
            const { needUpgrade, forceUpgrade, systemVersion, versionDesc, versionDescEn } = this.versionData || {}
            const locale = this.$i18n.locale
            const localePrefix = locale.split('-')[0]
            const localeKey = localePrefix.charAt(0).toUpperCase() + localePrefix.slice(1)
            let versionDescText
            if (localePrefix === 'zh') {
                versionDescText = versionDesc
            } else {
                versionDescText = this.versionData[`versionDesc${localeKey}`] || versionDescEn
            }
            const reg = /[;；]/g;
			versionDescText = versionDescText.replace(reg, "$&<br>");
            this.versionNotification = this.$notify({
                title: this.$t('common.versionUpdateNotice'),
                dangerouslyUseHTMLString: true,
                message: `
                    <div style="margin-top: 8px;">
                        <div style="display: flex; align-items: center; gap: 8px; margin-bottom: 12px;">
                            <span style="background: #e6f7ff; color: #1890ff; padding: 2px 8px; border-radius: 4px; font-size: 12px;">
                                ${this.$t('product.versionNumber')}：${systemVersion}
                            </span>
                        </div>
                        <div style="color: #595959; margin-bottom: 40px; font-size: 13px;white-space: normal; word-wrap: break-word;">
                            ${versionDescText}
                        </div>
                        <div style="position: absolute; bottom: 12px; right: 12px; display: flex; gap: 12px;">
                            <button 
                                style="border: none; background: none; color: #8c8c8c; cursor: pointer; font-size: 13px;"
                                onclick="window.closeVersionNotification()"
                            >
                                ${this.$t('common.later')}
                            </button>
                            <button 
                                style="border: none; background: #1890ff; color: white; padding: 4px 16px; border-radius: 4px; cursor: pointer; font-size: 13px; font-weight: 500;"
                                onclick="location.reload()"
                            >
                                ${this.$t('common.immediateUpdate')}
                            </button>
                        </div>
                    </div>
                `,
                duration: 0, // 不自动关闭
                showClose: true,
                position: 'top-right'
            });
            // 保存关闭方法到全局，供HTML中的按钮调用
            window.closeVersionNotification = () => {
                if (this.versionNotification) {
                    this.versionNotification.close();
                    this.versionNotification = null;
                    // 清理全局方法
                    delete window.closeVersionNotification;
                }
            };
        },
        toggleSideBar() {
            this.$store.dispatch('settings/toggleSideBar')
            timeout = setTimeout(this.resizeWindow, 280)
        },
        resizeWindow(e) {
            const navbarRef = this.$refs.navbarRef
            const routeNameRef = this.$refs.routeNameRef
            if (navbarRef && routeNameRef) {
                // const menuWidth = this.isCollapse ? 60 : 200
                const menuWidth = 40
                const widthValue = navbarRef.clientWidth - routeNameRef.clientWidth - this.hamburgerWidth - this.rightWidth - menuWidth
                if (widthValue > 100) {
                    this.showTagsView = true
                    // 这里需要根据实际情况调整宽度值，这里只是一个示例
                    this.tagsWidth = widthValue
                } else {
                    this.showTagsView = false
                }
                return
            }
            if (timeout) {
                clearTimeout(timeout)
                timeout = null
            }
            this.tagsWidth = 600
        },
        logout() {
            newLogout().then(res => {
                if (!res || typeof res !== 'object') return;
                const {success, code, message, data} = res
                if (success || ['200'].includes(String(code))) {
                    this.$store.dispatch('setMenuIds', []).then(() => {
                        this.$router.push('/login')
                        localStorage.removeItem('newToken')
                        this.updateToken('')
                        window.location.reload()
                    })
                } else {
                    this.$message({
                        type: 'error',
                        message: message,
                    });
                }
            })
        },
        handleRobotShow() {
            this.$store.dispatch('setShowRobot', !this.showRobot)
            if (this.showRobot) {
                document.addEventListener('click', this.handleOutsideClick);
            } else {
                document.removeEventListener('click', this.handleOutsideClick);
            }
        },
        handleOutsideClick(event) {
            if (this.$refs.modalRef && !this.$refs.modalRef.contains(event.target)) {
                this.handleRobotShow()
            }
        },
        handlePrefillShow() {
            this.$store.dispatch('setShowPrefill', !this.showPrefill)
            if (this.showPrefill) {
                document.addEventListener('click', this.handleOutsideClickPrefill);
            } else {
                document.removeEventListener('click', this.handleOutsideClickPrefill);
            }
        },
        handleOutsideClickPrefill(event) {
            if (this.$refs.modalRefPrefill && !this.$refs.modalRefPrefill.contains(event.target)) {
                this.handlePrefillShow()
            }
        },
        changeLanguage(command) {
            const lang = command;
            if (this.$i18n.locale === lang) {
                return;
            }

            this.$i18n.locale = lang;
            localStorage.setItem('Accept-Language', this.$i18n.locale);
            sessionStorage.setItem('Accept-Language', this.$i18n.locale);
            localStorage.setItem('languageChange', true);
            this.$router.go(0);
        },
    }
}
</script>

<style lang="scss" scoped>
@import "~@/styles/tailwind.scss";

.navbar {
    flex-shrink: 0;
    position: sticky;
    top: 0;
    padding: 0 15px;
    height: 60px;
    overflow: hidden;
    background: #fff;
    box-shadow: 0 1px 4px #00152914;
    z-index: 9;

    .menu-icon-class {
        width: 20px;
        height: 20px;
        margin-right: 10px;
    }

    .hamburger-container {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
        float: left;
        cursor: pointer;
        transition: background .3s;
        -webkit-tap-highlight-color: transparent;

        &:hover {
            background: rgba(0, 0, 0, .025)
        }
    }

    .breadcrumb-container {
        float: left;
    }

    .topmenu-container {
        position: absolute;
        left: 50px;
    }

    .errLog-container {
        display: inline-block;
        vertical-align: top;
    }

    .right-menu {
        float: right;
        height: 100%;
        line-height: 50px;

        &:focus {
            outline: none;
        }

        .right-menu-item {
            display: inline-block;
            padding: 0 8px;
            height: 100%;
            font-size: 18px;
            color: #5a5e66;
            vertical-align: text-bottom;

            &.hover-effect {
                cursor: pointer;
                transition: background .3s;

                &:hover {
                    background: rgba(0, 0, 0, .025)
                }
            }
        }

        .avatar-container {
            margin-right: 30px;

            .avatar-wrapper {
                margin-top: 5px;
                position: relative;

                // .user-avatar {
                //   cursor: pointer;
                //   width: 40px;
                //   height: 40px;
                //   border-radius: 10px;
                // }

                .el-icon-caret-bottom {
                    cursor: pointer;
                    position: absolute;
                    right: -20px;
                    top: 25px;
                    font-size: 12px;
                }
            }
        }
    }

    .user-avatar {
        cursor: pointer;
        width: 24px;
        height: 24px;
        border-radius: 10px;
    }

    .user {
        cursor: pointer;
    }
}

.chat-region {
    // position: relative;
    height: 100%;

    .img-region {
        margin-top: -4px;
        width: 26px;
        height: 100%;
        margin-right: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;

        :hover {
            opacity: 0.9;
        }

        img {
            width: 100%;
            height: 100%;
        }
    }

    .fastdeepseek-chatbot-window {
        border: none;
        position: fixed;
        flex-direction: column;
        justify-content: space-between;
        box-shadow: rgba(150, 150, 150, 0.2) 0px 10px 30px 0px, rgba(150, 150, 150, 0.2) 0px 0px 0px 1px;
        width: 375px;
        height: 667px;
        max-width: 90vw;
        max-height: 85vh;
        border-radius: 0.75rem;
        display: flex;
        z-index: 2147483647;
        overflow: hidden;
        left: unset;
        background-color: rgb(243, 244, 246);
        visibility: hidden;
        right: 44px;
        // bottom: 0px;
    }
}

.prefill-region {
    width: 600px;
    background: #7cb2eb33;
    border-radius: 20px;
    height: 700px;
    padding: 20px;
    display: flex;
    position: fixed;
    z-index: 2147483647;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    .prefill-window {
        box-shadow: rgba(150, 150, 150, 0.2) 0px 10px 30px 0px, rgba(150, 150, 150, 0.2) 0px 0px 0px 1px;
        width: 570px;
        height: 667px;
        max-width: 90vw;
        max-height: 85vh;
        border-radius: 0.75rem;
        display: flex;
        z-index: 2147483647;
        background-color: rgb(243, 244, 246);
    }
}

.el-dropdown-menu--medium .el-dropdown-menu__item {
    line-height: 40px;
    padding: 0 15px;
}
</style>

<style lang="scss">
.navbar {
    .el-input__prefix {
        top: 5px;
    }

    .el-input--prefix .el-input__inner {
        padding-left: 40px;
    }

    .select-language {
        width: 140px;
        margin-right: 20px;
    }

    .select-img {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 22px;
        height: 22px;

        img {
            width: 20px;
            height: 20px;
        }
    }
}
</style>
